<proffeo-ui-page-wrapper>
  <div
    [proffeoSpinner]="companyGroups() === undefined"
    proffeoSpinnerSize="lg"
    class="min-h-48 w-full pt-3 lg:pt-6"
  >
    @if (companyGroups(); as groups) {
      @for (companyGroup of groups; track companyGroup.id) {
        <div class="flex w-full p-5">
          <proffeo-company-groups-list
            [companyGroup]="companyGroup"
            class="w-full"
          ></proffeo-company-groups-list>
        </div>
      }
    }
  </div>
</proffeo-ui-page-wrapper>
